module.exports = __webpack_public_path__ + "img/applewhite.4cf3316c.svg";